export const DOCUMENT_TYPES = [
  { value: 'INSURANCE_POLICY', label: 'Insurance Policy' },
  { value: 'CERTIFICATE', label: 'Certificate of Insurance' },
  { value: 'ENDORSEMENT', label: 'Policy Endorsement' },
  { value: 'LOSS_RUN', label: 'Loss Run Report' },
  { value: 'CONTRACT', label: 'Contract' },
  { value: 'AGREEMENT', label: 'Agreement' },
  { value: 'AMENDMENT', label: 'Amendment' },
  { value: 'INSURANCE_REQ', label: 'Insurance Requirements' },
  { value: 'VENDOR_ASSESSMENT', label: 'Vendor Assessment' },
  { value: 'COMPLIANCE_DOC', label: 'Compliance Document' },
  { value: 'AUDIT_DOC', label: 'Audit Document' },
  { value: 'CLAIM_DOC', label: 'Claim Document' },
  { value: 'REPORT', label: 'Report' },
  { value: 'CORRESP', label: 'Correspondence' },
  { value: 'OTHER', label: 'Other' }
]

// Frontend Performance & UX Constants
export const UI_CONSTANTS = {
  // Pagination & Data Loading
  DEFAULT_PAGE_SIZE: 10,
  PAGE_SIZE_OPTIONS: [5, 10, 25, 50, 100],
  MAX_INITIAL_LOAD: 50, // Max items to load initially for large datasets
  SEARCH_DEBOUNCE_MS: 300,

  // Large Dataset Thresholds
  LARGE_DATASET_THRESHOLD: 1000, // Show search/pagination when > 1000 items
  VERY_LARGE_DATASET_THRESHOLD: 10000, // Force virtualization when > 10k items

  // Split Pane Configuration
  DEFAULT_SPLIT_RATIO: 0.5, // 50/50 split
  MIN_PANEL_WIDTH: 300, // Minimum width for panels in pixels
  RESIZER_WIDTH: 8, // Width of resizer handle

  // PDF Viewer Configuration
  PDF_CONFIG: {
    toolbar: 1, // Show toolbar
    navpanes: 0, // Hide navigation panel
    scrollbar: 1, // Show scrollbar
    view: 'FitH', // Fit horizontal
    zoom: 'auto'
  },

  // Virtual Scrolling
  VIRTUAL_SCROLL_ITEM_HEIGHT: 60, // Estimated height per item
  VIRTUAL_SCROLL_BUFFER: 10, // Items to render outside viewport

  // Loading States
  SKELETON_ITEM_COUNT: 5, // Number of skeleton items to show
  LOADING_DEBOUNCE_MS: 200, // Minimum loading time to prevent flicker

  // COI / compliance document upload (staff + secure-upload surfaces)
  COI_UPLOAD_ACCEPT: '.pdf,.doc,.docx',
  COI_UPLOAD_ACCEPT_LABEL: 'PDF, DOC, DOCX',
  COI_UPLOAD_SECURE_ACCEPT: '.pdf,.doc,.docx,.txt,.xls,.xlsx,.csv',
  COI_UPLOAD_SECURE_ACCEPT_LABEL: 'PDF, DOC, DOCX, TXT, XLS, XLSX, CSV',
  COI_UPLOAD_MIME_TYPES: [
    'application/pdf',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  ],

  // Gap-notification outreach batches (server caps a single send at 200)
  NOTIFICATION_BATCH_SIZE_OPTIONS: [10, 25, 50, 100, 200],
  DEFAULT_NOTIFICATION_BATCH_SIZE: 25,
  NOTIFICATION_SKIP_RECENT_DAYS: 7,
}

// US States and Territories
export const US_STATES = [
  { value: 'AL', label: 'Alabama' },
  { value: 'AK', label: 'Alaska' },
  { value: 'AZ', label: 'Arizona' },
  { value: 'AR', label: 'Arkansas' },
  { value: 'CA', label: 'California' },
  { value: 'CO', label: 'Colorado' },
  { value: 'CT', label: 'Connecticut' },
  { value: 'DE', label: 'Delaware' },
  { value: 'DC', label: 'District of Columbia' },
  { value: 'FL', label: 'Florida' },
  { value: 'GA', label: 'Georgia' },
  { value: 'HI', label: 'Hawaii' },
  { value: 'ID', label: 'Idaho' },
  { value: 'IL', label: 'Illinois' },
  { value: 'IN', label: 'Indiana' },
  { value: 'IA', label: 'Iowa' },
  { value: 'KS', label: 'Kansas' },
  { value: 'KY', label: 'Kentucky' },
  { value: 'LA', label: 'Louisiana' },
  { value: 'ME', label: 'Maine' },
  { value: 'MD', label: 'Maryland' },
  { value: 'MA', label: 'Massachusetts' },
  { value: 'MI', label: 'Michigan' },
  { value: 'MN', label: 'Minnesota' },
  { value: 'MS', label: 'Mississippi' },
  { value: 'MO', label: 'Missouri' },
  { value: 'MT', label: 'Montana' },
  { value: 'NE', label: 'Nebraska' },
  { value: 'NV', label: 'Nevada' },
  { value: 'NH', label: 'New Hampshire' },
  { value: 'NJ', label: 'New Jersey' },
  { value: 'NM', label: 'New Mexico' },
  { value: 'NY', label: 'New York' },
  { value: 'NC', label: 'North Carolina' },
  { value: 'ND', label: 'North Dakota' },
  { value: 'OH', label: 'Ohio' },
  { value: 'OK', label: 'Oklahoma' },
  { value: 'OR', label: 'Oregon' },
  { value: 'PA', label: 'Pennsylvania' },
  { value: 'RI', label: 'Rhode Island' },
  { value: 'SC', label: 'South Carolina' },
  { value: 'SD', label: 'South Dakota' },
  { value: 'TN', label: 'Tennessee' },
  { value: 'TX', label: 'Texas' },
  { value: 'UT', label: 'Utah' },
  { value: 'VT', label: 'Vermont' },
  { value: 'VA', label: 'Virginia' },
  { value: 'WA', label: 'Washington' },
  { value: 'WV', label: 'West Virginia' },
  { value: 'WI', label: 'Wisconsin' },
  { value: 'WY', label: 'Wyoming' },
]

// Canadian Provinces and Territories
export const CANADIAN_PROVINCES = [
  { value: 'AB', label: 'Alberta' },
  { value: 'BC', label: 'British Columbia' },
  { value: 'MB', label: 'Manitoba' },
  { value: 'NB', label: 'New Brunswick' },
  { value: 'NL', label: 'Newfoundland and Labrador' },
  { value: 'NS', label: 'Nova Scotia' },
  { value: 'NT', label: 'Northwest Territories' },
  { value: 'NU', label: 'Nunavut' },
  { value: 'ON', label: 'Ontario' },
  { value: 'PE', label: 'Prince Edward Island' },
  { value: 'QC', label: 'Quebec' },
  { value: 'SK', label: 'Saskatchewan' },
  { value: 'YT', label: 'Yukon' },
]

// Countries for address forms
export const COUNTRIES = [
  { value: 'US', label: 'United States' },
  { value: 'CA', label: 'Canada' },
  { value: 'OTHER', label: 'Other' },
]

// Contact roles matching backend Contact.ContactRole choices
export const CONTACT_ROLES = [
  { value: 'OWNER', label: 'Owner / Franchisee', group: 'Store / Franchisee' },
  { value: 'GENERAL_MANAGER', label: 'General Manager', group: 'Store / Franchisee' },
  { value: 'OPERATIONS_MANAGER', label: 'Operations Manager', group: 'Store / Franchisee' },
  { value: 'INSURANCE_CONTACT', label: 'Insurance / Risk Contact', group: 'Store / Franchisee' },
  { value: 'BILLING_CONTACT', label: 'Billing / Accounts Payable', group: 'Store / Franchisee' },
  { value: 'INSURANCE_AGENT', label: 'Insurance Agent / Producer', group: 'Insurance Agency' },
  { value: 'ACCOUNT_MANAGER', label: 'Account Manager', group: 'Insurance Agency' },
  { value: 'CLAIMS_HANDLER', label: 'Claims Handler', group: 'Insurance Agency' },
  { value: 'PRIMARY_CONTACT', label: 'Primary Contact', group: 'General' },
  { value: 'OTHER', label: 'Other', group: 'General' },
]

// API Response Size Limits (to prevent browser crashes)
export const API_LIMITS = {
  MAX_DOCUMENTS_PER_REQUEST: 500,
  MAX_ANALYSIS_RESULTS_PER_REQUEST: 100,
  MAX_ENTITIES_PER_REQUEST: 200,
  MAX_SEARCH_RESULTS: 1000,
}